import Button from '@axa-japan/design-system-react/Button';
import Heading from '@axa-japan/design-system-react/Heading';
import { ArrowIcon } from '@axa-japan/design-system-react/Icons';
import Text from '@axa-japan/design-system-react/Text';
import { useToast } from '@axa-japan/design-system-react/Toast';
import { QRCodeSVG } from 'qrcode.react';
import { useUserContext } from '../../providers/UserProvider';
import { AUTH_TYPE } from '../../types/auth';
import { DOCUMENT_UPLOAD_PROGRESS } from '../../types/session';

type QRCodeGenerationProps = {
  QRCodeValue: string;
  onBack: () => void;
};

const QRCodeGeneration: React.FC<QRCodeGenerationProps> = ({ QRCodeValue, onBack }) => {
  const triggerToast = useToast();
  const { connectionType, uploadStatus } = useUserContext();

  return (
    <div className="flex flex-col gap-10">
      <div className="bg-interactiveHoverGrey p-10 flex flex-col gap-4">
        <Heading as="h3">QRコード</Heading>
        <Text>お客さまのスマートフォン等でQRコードを読み取ってください。</Text>

        <QRCodeSVG className="mx-auto w-1/2 h-auto rounded" value={QRCodeValue} />
      </div>

      <div className="flex flex-col gap-4">
        <Heading as="h3">メールでのURL送付方法について</Heading>
        <div className="bg-interactiveHoverGrey p-6">
          <Text>
            お客様がQRコードを読み取れない場合は、下の「URLコピー」ボタンを押してください。URLがコピーされますので、メール本文にURLを貼り付けてお客様にお送りください。
          </Text>
          <div className="w-40 mx-auto pt-5">
            <Button
              variant="outlined"
              className="hover:bg-mercury p-3 w-28 rounded text-axaBlue font-semibold"
              onClick={() => {
                navigator.clipboard.writeText(QRCodeValue);
                triggerToast({
                  description: 'URLをコピーしました',
                });
              }}
            >
              URLコピー
            </Button>
          </div>
        </div>
      </div>

      {connectionType !== AUTH_TYPE.Internal && uploadStatus === DOCUMENT_UPLOAD_PROGRESS.completed && (
        <Text>
          撮影・送信が完了したことをお客様にご確認のうえ、「終了する」ボタンを押してください。<br></br>
          お客様のご都合で後日の撮影・送信となる場合、お客様のお手続き用URLの有効期限は発行から72時間（3日間）であることをお客様へお伝えください。
        </Text>
      )}
      <div className="w-80 mx-auto">
        {connectionType === AUTH_TYPE.Internal && (
          <Button type="button" onClick={onBack} fullWidth icon={<ArrowIcon />}>
            次へ
          </Button>
        )}
        {connectionType !== AUTH_TYPE.Internal && (
          <Button variant="outlined" type="button" onClick={onBack} fullWidth icon={<ArrowIcon rotation="180" />} iconPosition="left">
            戻る
          </Button>
        )}
      </div>
    </div>
  );
};

export default QRCodeGeneration;
